import React, {useContext} from 'react';
import NavBarLink from '../../NavBarLink';
import IfCartUser from '../../../IfCartUser';
import { savedCartContext } from '../../../../Context/savedCartContext';

function CartNavBarLink() {
  const { savedCartDetails } = useContext(savedCartContext);
  const { savedCart, cartItems } = savedCartDetails;

  console.log('savedC', savedCartDetails)

  let itemCount = 0;
  if(savedCart !== null && cartItems !== null) {
    itemCount = Object.keys(cartItems).length;
  }

  return (
    <IfCartUser>
      <NavBarLink to="/my-cart">
        My Cart
        { itemCount > 0 ? `(${itemCount})` : ''}
      </NavBarLink>
    </IfCartUser>
  );
}

export default CartNavBarLink;
